(function () {
  "use strict";

  function init(root) {
    root.querySelectorAll("[data-fsh-section]:not([data-fsh-ready])").forEach(function (section) {
      section.setAttribute("data-fsh-ready", "true");

      var items = section.querySelectorAll(".fsh-r");
      var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      function revealAll() {
        if (section.dataset.fshShown === "true") {
          return;
        }

        section.dataset.fshShown = "true";

        window.requestAnimationFrame(function () {
          items.forEach(function (el) {
            el.classList.add("on");
          });
        });
      }

      /* No animation for reduced-motion — just show everything */
      if (reducedMotion) {
        items.forEach(function (el) { el.classList.add("on"); });
        return;
      }

      /* Arm the CSS: only now does opacity:0 kick in */
      section.setAttribute("data-fsh-js", "true");

      function startRevealObserver() {
        /* No IntersectionObserver support — reveal immediately */
        if (!("IntersectionObserver" in window)) {
          revealAll();
          return;
        }

        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;

              revealAll();

              items.forEach(function (el) {
                observer.unobserve(el);
              });
            });
          },
          { threshold: 0.12, rootMargin: "0px 0px -50px 0px" }
        );

        items.forEach(function (el) { observer.observe(el); });
      }

      window.requestAnimationFrame(startRevealObserver);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
